import React, { useState } from 'react';
import { CheckCircleIcon, MicIcon, XIcon } from 'lucide-react';
import { ChatInput } from './ChatInput';
import { Logo } from './common/Logo';
import { NotificationButton } from './NotificationButton';
interface InitialViewProps {
  onSendMessage: (message: string) => void;
  isVoiceMode: boolean;
  onToggleVoiceMode: () => void;
}
export const InitialView = ({
  onSendMessage,
  isVoiceMode,
  onToggleVoiceMode
}: InitialViewProps) => {
  return <>
      <div className="flex-grow flex flex-col justify-center items-center p-6 md:p-8 overflow-auto bg-[#0a1120] relative" data-id="element-119">
        {isVoiceMode && <div className="absolute inset-0 z-50 bg-command-app/98 backdrop-blur-2xl flex flex-col items-center justify-center p-8 animate-fade-in" data-id="element-120">
            <button onClick={onToggleVoiceMode} className="absolute top-8 right-8 p-4 hover:bg-white/5 rounded-full text-command-text-muted hover:text-white transition-colors z-50" data-id="element-121">
              <XIcon size={32} className="text-[#4a90e2]" data-id="element-122" />
            </button>

            <div className="relative mb-16" data-id="element-123">
              <div className="w-64 h-64 p-[2px] rounded-full running-border relative z-10 flex items-center justify-center" data-id="element-124">
                <div className="w-full h-full rounded-full bg-command-sidebar relative z-10 flex items-center justify-center" data-id="element-125">
                  <Logo size={120} className="text-[#4a90e2]" data-id="element-126" />
                </div>
              </div>
            </div>

            <div className="text-center max-w-2xl animate-slide-up" data-id="element-127">
              <div className="flex items-center justify-center gap-2 mb-4" data-id="element-128">
                <div className="w-2 h-2 rounded-full bg-[#f59e0b] animate-pulse" data-id="element-129" />
                <span className="text-xs font-bold text-[#f59e0b] uppercase tracking-[0.3em]" data-id="element-130">
                  Listening
                </span>
              </div>
              <p className="text-3xl md:text-4xl font-medium text-white leading-tight opacity-90" data-id="element-131"></p>
            </div>
          </div>}
        <div className="absolute top-6 right-6" data-id="element-132">
          <NotificationButton data-id="element-133" />
        </div>
        <h1 className="text-2xl md:text-3xl font-semibold text-[#a0a0a0] mb-12 flex items-center gap-3" data-id="element-134">
          <span data-id="element-135">
            {isVoiceMode ? "I'm listening..." : 'Welcome back, Sergeant Miller.'}
          </span>
        </h1>

        <div className="w-full max-w-[1000px]" data-id="element-136">
          <ChatInput onSendMessage={onSendMessage} isVoiceMode={isVoiceMode} onToggleVoiceMode={onToggleVoiceMode} data-id="element-137" />
          <p className="mt-4 text-center text-[10px] text-command-text-muted leading-relaxed max-w-[800px] mx-auto opacity-60" data-id="element-138">
            AI may summarize agency knowledge, but can make mistakes. Verify
            critical facts, legal authority, and policy requirements before
            taking action.
          </p>
        </div>
      </div>
    </>;
};